import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useGQL_teams } from '@/contexts/graphql-and-swr-apis'
import { PageContentWrapper } from '@unwrittenmedia/simple-components'
import SimplePageHeader2 from '@/components/SimplePageHeader2'
import { TeamCard } from '@/components/team/TeamCard'

export const Route = createFileRoute('/venues/')({
  component: VenuesPage,
})

function VenuesPage() {
  const navigate = useNavigate()
  const { data, error, isLoading } = useGQL_teams()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-900 dark:text-white">Loading teams...</div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-red-600 dark:text-red-400">Error loading teams: {error.message}</div>
      </div>
    )
  }

  const teamsRaw = data?.teams || [];
  const teams = teamsRaw.filter(team => !team.deleted).sort((a, b) => a.name.localeCompare(b.name));
  const teamsDeleted = teamsRaw.filter(team => team.deleted).sort((a, b) => a.name.localeCompare(b.name));

  return (
    <PageContentWrapper>
      <SimplePageHeader2
        title="Teams"
        description="A list of all your teams, their associated places, and where they are."
        additionalDescription='Use this area to configure each building or room or logical grouping for your venues. (i.e., "Main Campus", "Downtown Campus", "Youth Room", "Spanish Service", etc.). Each place should represent a physical or virtual location where events are held, and should only have 1 event live at a time.'
        actionButtonText="Add team"
        actionButtonOnClick={() => {
          navigate({ to: '/team/add-team' })
        }}
      />

      <div className="mt-8 space-y-8">
        {teams.length === 0 && teamsDeleted.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-500 dark:text-mist-500">No teams found.</p>
          </div>
        ) : (<div>
          {teams.map((team) => (
            <TeamCard key={team.id} team={team} className="mb-4" />
          ))}
          {teamsDeleted.map((team) => (
            <TeamCard key={team.id} team={team} className="mb-4" />
          ))}
        </div>)}
      </div>
    </PageContentWrapper>
  )
}
